export default {
	"message": {
		"temperturePerson": "温度异常短信通知人员",
		"transferPerson": "运输订单审核人",
		"dispatcher": "派车单调度人",
		"specifyPerson": "指定通知人",
		"limitationPerson": "时效异常短信通知人员",
		"mailPerson": "调度邮件抄送人",
		"scheduPerson": "调度短信抄送人"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/message/message.js